import { Option } from "src/components/Form/DropdownSelect/Options";
import { ReactComponent as X } from "src/assets/svg/x5.svg";

interface IToggleButton {
  label: string;
  name?: string; // form field name
  value?: Option | Option[];
  disabled?: boolean;
  current?: string; // Current selected input
  setCurrent: (c: string) => void;
  removeFromOptions?: (name, value) => void;
  placeholder?: string;
}

const ToggleButton = ({
  label,
  name,
  value,
  disabled,
  current,
  setCurrent,
  placeholder = "select",
  removeFromOptions
}: IToggleButton) => {
  const selected = label === current;
  const isArr = Array.isArray(value);
  const text = isArr ? value.length && value.map((v) => v.label).join(", ") : value?.label;

  const arr_value = isArr ? value : value ? [value] : undefined;

  return (
    <div>
      <p className="mb-2 font-poppins text-base text-[#8A8A8A] font-medium">{label}</p>
      <button
        disabled={disabled}
        onClick={() => setCurrent(label)}
        className={`w-[410px] flex items-center py-3 px-4 rounded-lg border-[1px] font-poppins font-medium text-sm hover:text-odfblue hover:border-odfblue 
            ${selected && "text-odfblue border-odfblue"}
            ${disabled && "bg-[#F5F5F5] cursor-not-allowed text-[#C1C1C1] border-[#E0E0E0] hover:border-[#E0E0E0] hover:text-[#C1C1C1]"}`}
      >
        <p
          className={`max-w-[300px] overflow-hidden text-ellipsis text-nowrap ${!value && "!text-[#8A8A8A]"}`}
        >
          {text || placeholder}
        </p>
        <p className="ml-auto text-xs">►</p>
      </button>

      {/* Badges if is multi */}
      {!!arr_value?.length && (
        <div className="flex flex-wrap gap-1 mt-4">
          {arr_value.map((v) => (
            <div
              key={v.label}
              className="flex gap-2 p-2 bg-[#F9F9F9] rounded-lg font-poppins font-medium text-sm text-odfblue "
            >
              {v.label}
              <X
                onClick={() => removeFromOptions?.(name, v.value)}
                className="cursor-pointer w-4 h-4"
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ToggleButton;
